import AppLayout from '@amzn/awsui-components-react/polaris/app-layout';
import HomepageContent from './HomepageContent';
import './styles.scss';

export default function Homepage(props) {
  return (
    <AppLayout
      content={<HomepageContent {...props}/>}
      contentType="default"
      navigationHide={true}
      toolsHide={true}
      disableContentPaddings={true}
    />
  );
}
